module.exports = "/_next/static/images/payments-collected-on-time-eda3727af2c0ae1b2d707b9ec42f85a0.png";